
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/x/react-chat/backend/controlled-state",
      function () {
        return require("private-next-pages/x/react-chat/backend/controlled-state.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/x/react-chat/backend/controlled-state"])
      });
    }
  